"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14L0 0H1.33333V14C1.33333 14.1768 1.40357 14.3464 1.5286 14.4714C1.65362 14.5964 1.82319 14.6667 2 14.6667H16V16Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.6664 7.3335H9.33301V13.3335H10.6664V7.3335Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.33333 7.3335H4V13.3335H5.33333V7.3335Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.3333 4H12V13.3333H13.3333V4Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.99935 4H6.66602V13.3333H7.99935V4Z",
    fill: fill
  }));
};

exports["default"] = _default;